import List from "@/components/list";
const Table = args => {
  const AccountTableConfig = [
    {
      label: "手机号码",
      prop: "toUserMobile"
    },
    {
      label: "消息内容",
      prop: "mqContent",
      showOverflowTooltip: true,
      minWidth: 300
    }
  ];
  return <List {...args} talbeCols={AccountTableConfig} />;
};

export default Table;
